// #region types
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
// #endregion

// #region components
import { TranslationKeys } from "translations";
import { DateConstants, IconDefinitionConstants } from "utils/constants";
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";
import EarlyPayoutFormContainer from "./forms/earlyPayoutFormContainer";
import EarlyPayoutList from "./_partials/earlyPayoutList";
// #endregion

function useEarlyPayoutDialog() {
  const getEarlyPayoutDialog = (onEarlyPayoutSubmit?: () => void, employee?: AutocompleteListItem): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.ExtraPayoutTitle),
      titleIcon: IconDefinitionConstants.WMoney,
      actions: [
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve),
          successMessage: TranslationKeys.Salary.ExtraPayoutSubmitSuccess,
        },
      ],
      dialogType: DialogEnums.DialogType.Content,
      maxWidth: "sm",
      children: <EarlyPayoutFormContainer preSelectedEmployee={employee} />,
      onSubmit: onEarlyPayoutSubmit,
    };
  };

  const getEarlyPayoutListDialog = (personId: number, yearMonth: number, personName: string): DialogProps => {
    const monthName = LocalizationHelperInstance.getFormattedDate(
      DateHelper.getDateFromYearMonth(yearMonth),
      DateConstants.MonthLongConfig
    );

    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Salary.ExtraPayoutListTitle),
      subTitle: `${personName}, ${monthName}`,
      titleIcon: IconDefinitionConstants.WMoney,
      maxWidth: "sm",
      dialogType: DialogEnums.DialogType.Content,
      hideFooter: true,
      children: <EarlyPayoutList personId={personId} yearMonth={yearMonth} />,
    };
  };

  return { getEarlyPayoutDialog, getEarlyPayoutListDialog };
}

export default useEarlyPayoutDialog;
